import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SeoService } from '../../seo/seo.service';
import { CommonModule } from '@angular/common';

@Component({
  standalone: true,
  selector: 'app-domestica',
  imports: [CommonModule],
  templateUrl: './domestica.html',
  styleUrls: ['./domestica.scss'],
})
export class DomesticaComponent implements OnInit {
  constructor(private router: Router, private seo: SeoService) {}

  ngOnInit(): void {
    this.seo.updateTags({
      title: 'Pulizie domestiche a Pescara | SAMI Pulizie',
      description:
        'Pulizie domestiche professionali a Pescara: camere, cucina, bagni, soggiorno, vetri e serrande. Interventi regolari o occasionali. Sopralluogo gratuito.',
      keywords:
        'pulizie domestiche Pescara, pulizia casa Pescara, pulizia appartamenti, pulizia bagni cucina, pulizia vetri, SAMI Pulizie',
      canonicalUrl: '/domestica',

      ogTitle: 'Pulizie domestiche a Pescara | SAMI Pulizie',
      ogDescription:
        'Servizio professionale di pulizia casa: camere, bagni, cucina, vetri e superfici. Sopralluogo gratuito.',
      ogImage: '/assets/logo.png',
      ogType: 'website',

      twitterCard: 'summary_large_image',
      twitterTitle: 'Pulizie domestiche a Pescara | SAMI Pulizie',
      twitterDescription:
        'Pulizia casa professionale a Pescara: interventi su misura e sopralluogo gratuito.',
      twitterImage: '/assets/logo.png',

      jsonLd: {
        '@context': 'https://schema.org',
        '@type': 'Service',
        name: 'Pulizie domestiche',
        description:
          'Pulizia casa professionale: camere, cucina, bagni, soggiorno, vetri e serrande su richiesta.',
        provider: {
          '@type': 'CleaningService',
          name: 'SAMI Pulizie',
          url: 'https://samipulizie.it/',
          logo: 'https://samipulizie.it/assets/logo.png',
        },
        areaServed: { '@type': 'City', name: 'Pescara' },
        url: 'https://samipulizie.it/domestica',
      },
    });
  }

  navigateToPreventiviSito() {
    this.router.navigateByUrl('/preventivo');
  }
}
